var Afghanistan = "อัฟกานิสถาน";
var Albania = "แอลเบเนีย";
var Algeria = "แอลจีเรีย";
var Andorra = "อันดอร์รา";
var Angola = "แองโกลา";
var Anguilla = "แองกวิลลา";
var Antarctica = "แอนตาร์กติกา";
var Argentina = "อาร์เจนตินา";
var Armenia = "อาร์เมเนีย";
var Aruba = "อารูบา";
var Australia = "ออสเตรเลีย";
var Austria = "ออสเตรีย";
var Azerbaijan = "อาเซอร์ไบจาน";
var Bahamas = "บาฮามาส";
var Bahrain = "บาห์เรน";
var Bangladesh = "บังกลาเทศ";
var Barbados = "บาร์เบโดส";
var Belarus = "เบลารุส";
var Belgium = "เบลเยียม";
var Belize = "เบลีซ";
var Benin = "เบนิน";
var Bermuda = "เบอร์มิวดา";
var Bhutan = "ภูฏาน";
var Bolivia = "โบลิเวีย";
var Botswana = "บอตสวานา";
var Brazil = "บราซิล";
var Bulgaria = "บัลแกเรีย";
var Burundi = "บุรุนดี";
var Cambodia = "กัมพูชา";
var Cameroon = "แคเมอรูน";
var Canada = "แคนาดา";
var Chad = "ชาด";
var Chile = "ชิลี";
var China = "จีน";
var Colombia = "โคลอมเบีย";
var Comoros = "คอโมโรส";
var Congo = "คองโก";
var Croatia = "โครเอเชีย";
var Cuba = "คิวบา";
var Cyprus = "ไซปรัส";
var Denmark = "เดนมาร์ก";
var Djibouti = "จิบูตี";
var Dominica = "โดมินิกา";
var Ecuador = "เอกวาดอร์";
var Egypt = "อียิปต์";
var Eritrea = "เอริเทรีย";
var Estonia = "เอสโตเนีย";
var Ethiopia = "เอธิโอเปีย";
var Fiji = "ฟิจิ";
var Finland = "ฟินแลนด์";
var France = "ฝรั่งเศส";
var Gabon = "กาบอง";
var Gambia = "แกมเบีย";
var Georgia = "จอร์เจีย";
var Germany = "เยอรมนี";
var Ghana = "กานา";
var Gibraltar = "ยิบรอลตาร์";
var Greece = "กรีซ";
var Greenland = "กรีนแลนด์";
var Grenada = "เกรนาดา";
var Guadeloupe = "กวาเดอลูป";
var Guam = "กวม";
var Guatemala = "กัวเตมาลา";
var Guernsey = "เกิร์นซีย์";
var Guinea = "กินี";
var Guyana = "กายอานา";
var Haiti = "เฮติ";
var Honduras = "ฮอนดูรัส";
var Hungary = "ฮังการี";
var Iceland = "ไอซ์แลนด์";
var India = "อินเดีย";
var Indonesia = "อินโดนีเซีย";
var Iraq = "อิรัก";
var Ireland = "ไอร์แลนด์";
var Israel = "อิสราเอล";
var Italy = "อิตาลี";
var Jamaica = "จาเมกา";
var Japan = "ญี่ปุ่น";
var Jersey = "เจอร์ซีย์";
var Jordan = "จอร์แดน";
var Kazakhstan = "คาซัคสถาน";
var Kenya = "เคนยา";
var Kiribati = "คิริบาตี";
var Kuwait = "คูเวต";
var Kyrgyzstan = "คีร์กีซสถาน";
var Latvia = "ลัตเวีย";
var Lebanon = "เลบานอน";
var Lesotho = "เลโซโท";
var Liberia = "ไลบีเรีย";
var Libya = "สาธารณรัฐอาหรับลิเบีย";
var Liechtenstein = "ลิกเตนสไตน์";
var Lithuania = "ลิทัวเนีย";
var Luxembourg = "ลักเซมเบิร์ก";
var Macao = "มาเก๊า";
var Madagascar = "มาดากัสการ์";
var Malawi = "มาลาวี";
var Malaysia = "มาเลเซีย";
var Maldives = "มัลดีฟส์";
var Mali = "มาลี";
var Malta = "มอลตา";
var Martinique = "มาร์ตีนีก";
var Mauritania = "มอริเตเนีย";
var Mauritius = "มอริเชียส";
var Mayotte = "มายอต";
var Mexico = "เม็กซิโก";
var Monaco = "โมนาโก";
var Mongolia = "มองโกเลีย";
var Montenegro = "มอนเตเนโกร";
var Montserrat = "มอนต์เซอร์รัต";
var Morocco = "โมร็อกโก";
var Mozambique = "โมซัมบิก";
var Myanmar = "เมียนมา";
var Namibia = "นามิเบีย";
var Nauru = "นาอูรู";
var Nepal = "เนปาล";
var Netherlands = "เนเธอร์แลนด์";
var Nicaragua = "นิการากัว";
var Niger = "ไนเจอร์";
var Nigeria = "ไนจีเรีย";
var Niue = "นีวเว";
var Norway = "นอร์เวย์";
var Oman = "โอมาน";
var Pakistan = "ปากีสถาน";
var Palau = "ปาเลา";
var Panama = "ปานามา";
var Paraguay = "ปารากวัย";
var Peru = "เปรู";
var Philippines = "ฟิลิปปินส์";
var Pitcairn = "พิตแคร์น";
var Poland = "โปแลนด์";
var Portugal = "โปรตุเกส";
var Qatar = "กาตาร์";
var Romania = "โรมาเนีย";
var Rwanda = "รวันดา";
var Samoa = "ซามัว";
var Senegal = "เซเนกัล";
var Serbia = "เซอร์เบีย";
var Seychelles = "เซเชลส์";
var Singapore = "สิงคโปร์";
var Slovakia = "สโลวาเกีย";
var Slovenia = "สโลวีเนีย";
var Somalia = "โซมาเลีย";
var Spain = "สเปน";
var Sudan = "ซูดาน";
var Suriname = "ซูรินาเม";
var Swaziland = "สวาซิแลนด์";
var Sweden = "สวีเดน";
var Switzerland = "สวิตเซอร์แลนด์";
var Taiwan = "ไต้หวัน";
var Tajikistan = "ทาจิกิสถาน";
var Thailand = "ไทย";
var Togo = "โตโก";
var Tokelau = "โตเกเลา";
var Tonga = "ตองกา";
var Tunisia = "ตูนิเซีย";
var Turkey = "ตุรกี";
var Turkmenistan = "เติร์กเมนิสถาน";
var Tuvalu = "ตูวาลู";
var Uganda = "ยูกันดา";
var Ukraine = "ยูเครน";
var Uruguay = "อุรุกวัย";
var Uzbekistan = "อุซเบกิสถาน";
var Vanuatu = "วานูอาตู";
var Venezuela = "เวเนซูเอลา";
var Yemen = "เยเมน";
var Zambia = "แซมเบีย";
var Zimbabwe = "ซิมบับเว";
var countries = {
	"Country or region": "ประเทศหรือภูมิภาค",
	"United States": "สหรัฐอเมริกา",
	Afghanistan: Afghanistan,
	"Åland Islands": "หมู่เกาะโอลันด์",
	Albania: Albania,
	Algeria: Algeria,
	"American Samoa": "อเมริกันซามัว",
	Andorra: Andorra,
	Angola: Angola,
	Anguilla: Anguilla,
	Antarctica: Antarctica,
	"Antigua and Barbuda": "แอนติกาและบาร์บูดา",
	Argentina: Argentina,
	Armenia: Armenia,
	Aruba: Aruba,
	Australia: Australia,
	Austria: Austria,
	Azerbaijan: Azerbaijan,
	Bahamas: Bahamas,
	Bahrain: Bahrain,
	Bangladesh: Bangladesh,
	Barbados: Barbados,
	Belarus: Belarus,
	Belgium: Belgium,
	Belize: Belize,
	Benin: Benin,
	Bermuda: Bermuda,
	Bhutan: Bhutan,
	Bolivia: Bolivia,
	"Bosnia and Herzegovina": "บอสเนียและเฮอร์เซโกวีนา",
	Botswana: Botswana,
	"Bouvet Island": "เกาะบูเว",
	Brazil: Brazil,
	"British Indian Ocean Territory": "บริติชอินเดียนโอเชียนเทร์ริทอรี",
	"Brunei Darussalam": "บรูไนดารุสซาลาม",
	Bulgaria: Bulgaria,
	"Burkina Faso": "บูร์กินาฟาโซ",
	Burundi: Burundi,
	Cambodia: Cambodia,
	Cameroon: Cameroon,
	Canada: Canada,
	"Cape Verde": "เคปเวิร์ด",
	"Cayman Islands": "หมู่เกาะเคย์แมน",
	"Central African Republic": "สาธารณรัฐแอฟริกากลาง",
	Chad: Chad,
	Chile: Chile,
	China: China,
	"Christmas Island": "เกาะคริสต์มาส",
	"Cocos (Keeling) Islands": "ดินแดนหมู่เกาะโคโคส (คีลิง)",
	Colombia: Colombia,
	Comoros: Comoros,
	Congo: Congo,
	"Congo, The Democratic Republic of The": "สาธารณรัฐประชาธิปไตยคองโก",
	"Cook Islands": "หมู่เกาะคุก",
	"Costa Rica": "คอสตาริกา",
	"Côte d'Ivoire": "โกตดิวัวร์",
	Croatia: Croatia,
	Cuba: Cuba,
	Cyprus: Cyprus,
	"Czech Republic": "สาธารณรัฐเช็ก",
	Denmark: Denmark,
	Djibouti: Djibouti,
	Dominica: Dominica,
	"Dominican Republic": "สาธารณรัฐโดมินิกัน",
	Ecuador: Ecuador,
	Egypt: Egypt,
	"El Salvador": "เอลซัลวาดอร์",
	"Equatorial Guinea": "อิเควทอเรียลกินี",
	Eritrea: Eritrea,
	Estonia: Estonia,
	Ethiopia: Ethiopia,
	"Falkland Islands (Malvinas)": "หมู่เกาะฟอล์กแลนด์ (มัลบินัส)",
	"Faroe Islands": "หมู่เกาะแฟโร",
	Fiji: Fiji,
	Finland: Finland,
	France: France,
	"French Guiana": "เฟรนช์เกียนา",
	"French Polynesia": "เฟรนช์พอลินีเชีย",
	"French Southern Territories": "เฟรนช์เซาเทิร์น",
	Gabon: Gabon,
	Gambia: Gambia,
	Georgia: Georgia,
	Germany: Germany,
	Ghana: Ghana,
	Gibraltar: Gibraltar,
	Greece: Greece,
	Greenland: Greenland,
	Grenada: Grenada,
	Guadeloupe: Guadeloupe,
	Guam: Guam,
	Guatemala: Guatemala,
	Guernsey: Guernsey,
	Guinea: Guinea,
	"Guinea-Bissau": "กินี-บิสเซา",
	Guyana: Guyana,
	Haiti: Haiti,
	"Heard Island and McDonald Islands": "เกาะเฮิร์ดและหมู่เกาะแมกดอนัลด์",
	"Holy See (Vatican City State)": "ำนักตำหนัก (นครรัฐวาติกัน)",
	Honduras: Honduras,
	"Hong Kong": "ฮ่องกง",
	Hungary: Hungary,
	Iceland: Iceland,
	India: India,
	Indonesia: Indonesia,
	"Iran, Islamic Republic of": "สาธารณรัฐอิสลามอิหร่าน",
	Iraq: Iraq,
	Ireland: Ireland,
	"Isle of Man": "ไอล์ออฟแมน",
	Israel: Israel,
	Italy: Italy,
	Jamaica: Jamaica,
	Japan: Japan,
	Jersey: Jersey,
	Jordan: Jordan,
	Kazakhstan: Kazakhstan,
	Kenya: Kenya,
	Kiribati: Kiribati,
	"Korea, Democratic People’s Republic of": "สาธารณรัฐประชาธิปไตยประชาชนเกาหลี",
	"Korea, Republic of": "สาธารณรัฐเกาหลี",
	Kuwait: Kuwait,
	Kyrgyzstan: Kyrgyzstan,
	"Lao People's Democratic Republic": "สาธารณรัฐประชาธิปไตยประชาชนลาว",
	Latvia: Latvia,
	Lebanon: Lebanon,
	Lesotho: Lesotho,
	Liberia: Liberia,
	Libya: Libya,
	Liechtenstein: Liechtenstein,
	Lithuania: Lithuania,
	Luxembourg: Luxembourg,
	Macao: Macao,
	"Macedonia, The Former Yugoslav Republic of": "อดีตสาธารณรัฐยูโกสลาเวียแห่งมาซิโดเนีย",
	Madagascar: Madagascar,
	Malawi: Malawi,
	Malaysia: Malaysia,
	Maldives: Maldives,
	Mali: Mali,
	Malta: Malta,
	"Marshall Islands": "หมู่เกาะมาร์แชลล์",
	Martinique: Martinique,
	Mauritania: Mauritania,
	Mauritius: Mauritius,
	Mayotte: Mayotte,
	Mexico: Mexico,
	"Micronesia, Federated States of": "สหพันธรัฐไมโครนีเซีย",
	"Moldova, Republic of": "สาธารณรัฐมอลโดวา",
	Monaco: Monaco,
	Mongolia: Mongolia,
	Montenegro: Montenegro,
	Montserrat: Montserrat,
	Morocco: Morocco,
	Mozambique: Mozambique,
	Myanmar: Myanmar,
	Namibia: Namibia,
	Nauru: Nauru,
	Nepal: Nepal,
	Netherlands: Netherlands,
	"Netherlands Antilles": "เนเธอร์แลนด์แอนทิลลีส",
	"New Caledonia": "นิวแคลิโดเนีย",
	"New Zealand": "นิวซีแลนด์",
	Nicaragua: Nicaragua,
	Niger: Niger,
	Nigeria: Nigeria,
	Niue: Niue,
	"Norfolk Island": "เกาะนอร์ฟอล์ก",
	"Northern Mariana Islands": "หมู่เกาะนอร์เทิร์นมาเรียนา",
	Norway: Norway,
	Oman: Oman,
	Pakistan: Pakistan,
	Palau: Palau,
	"Palestine, State of": "ดินแดนของปาเลสไตน์ที่ถูกยึดครอง",
	Panama: Panama,
	"Papua New Guinea": "ปาปัวนิวกินี",
	Paraguay: Paraguay,
	Peru: Peru,
	Philippines: Philippines,
	Pitcairn: Pitcairn,
	Poland: Poland,
	Portugal: Portugal,
	"Puerto Rico": "ปวยร์โตรีโก",
	Qatar: Qatar,
	"Réunion": "เรอูว์นียง",
	Romania: Romania,
	"Russian Federation": "สหพันธรัฐรัสเซีย",
	Rwanda: Rwanda,
	"Saint Helena": "เซนต์เฮเลนา",
	"Saint Kitts and Nevis": "เซนต์คิตส์และเนวิส",
	"Saint Lucia": "เซนต์ลูเซีย",
	"Saint Pierre and Miquelon": "แซ็งปีแยร์และมีเกอลง",
	"Saint Vincent and The Grenadines": "เซนต์วินเซนต์และเกรนาดีนส์",
	Samoa: Samoa,
	"San Marino": "ซานมารีโน",
	"Sao Tome and Principe": "เซาตูเมและปรินซิปี",
	"Saudi Arabia": "ซาอุดีอาระเบีย",
	Senegal: Senegal,
	Serbia: Serbia,
	Seychelles: Seychelles,
	"Sierra Leone": "เซียร์ราลีโอน",
	Singapore: Singapore,
	Slovakia: Slovakia,
	Slovenia: Slovenia,
	"Solomon Islands": "หมู่เกาะโซโลมอน",
	Somalia: Somalia,
	"South Africa": "แอฟริกาใต้",
	"South Georgia and The South Sandwich Islands": "เกาะเซาท์จอร์เจียและหมู่เกาะเซาท์แซนด์วิช",
	Spain: Spain,
	"Sri Lanka": "ศรีลังกา",
	Sudan: Sudan,
	Suriname: Suriname,
	"Svalbard and Jan Mayen": "สฟาลบาร์และยานไมเอน",
	Swaziland: Swaziland,
	Sweden: Sweden,
	Switzerland: Switzerland,
	"Syrian Arab Republic": "สาธารณรัฐอาหรับซีเรีย",
	Taiwan: Taiwan,
	Tajikistan: Tajikistan,
	"Tanzania, United Republic of": "สหสาธารณรัฐแทนซาเนีย",
	Thailand: Thailand,
	"Timor-Leste": "ติมอร์-เลสเต",
	Togo: Togo,
	Tokelau: Tokelau,
	Tonga: Tonga,
	"Trinidad and Tobago": "ตรินิแดดและโตเบโก",
	Tunisia: Tunisia,
	Turkey: Turkey,
	Turkmenistan: Turkmenistan,
	"Turks and Caicos Islands": "หมู่เกาะเติกส์และเคคอส",
	Tuvalu: Tuvalu,
	Uganda: Uganda,
	Ukraine: Ukraine,
	"United Arab Emirates": "สหรัฐอาหรับเอมิเรตส์",
	"United Kingdom": "สหราชอาณาจักร",
	"United States Minor Outlying Islands": "เกาะเล็กรอบนอกของสหรัฐอเมริกา",
	Uruguay: Uruguay,
	Uzbekistan: Uzbekistan,
	Vanuatu: Vanuatu,
	Venezuela: Venezuela,
	"Viet Nam": "เวียดนาม",
	"Virgin Islands, British": "หมู่เกาะบริติชเวอร์จิน",
	"Virgin Islands, U.S.": "หมู่เกาะเวอร์จินของสหรัฐ",
	"Wallis and Futuna": "วอลิสและฟูตูนา",
	"Western Sahara": "ซาฮาราตะวันตก",
	Yemen: Yemen,
	Zambia: Zambia,
	Zimbabwe: Zimbabwe
};

export { Afghanistan, Albania, Algeria, Andorra, Angola, Anguilla, Antarctica, Argentina, Armenia, Aruba, Australia, Austria, Azerbaijan, Bahamas, Bahrain, Bangladesh, Barbados, Belarus, Belgium, Belize, Benin, Bermuda, Bhutan, Bolivia, Botswana, Brazil, Bulgaria, Burundi, Cambodia, Cameroon, Canada, Chad, Chile, China, Colombia, Comoros, Congo, Croatia, Cuba, Cyprus, Denmark, Djibouti, Dominica, Ecuador, Egypt, Eritrea, Estonia, Ethiopia, Fiji, Finland, France, Gabon, Gambia, Georgia, Germany, Ghana, Gibraltar, Greece, Greenland, Grenada, Guadeloupe, Guam, Guatemala, Guernsey, Guinea, Guyana, Haiti, Honduras, Hungary, Iceland, India, Indonesia, Iraq, Ireland, Israel, Italy, Jamaica, Japan, Jersey, Jordan, Kazakhstan, Kenya, Kiribati, Kuwait, Kyrgyzstan, Latvia, Lebanon, Lesotho, Liberia, Libya, Liechtenstein, Lithuania, Luxembourg, Macao, Madagascar, Malawi, Malaysia, Maldives, Mali, Malta, Martinique, Mauritania, Mauritius, Mayotte, Mexico, Monaco, Mongolia, Montenegro, Montserrat, Morocco, Mozambique, Myanmar, Namibia, Nauru, Nepal, Netherlands, Nicaragua, Niger, Nigeria, Niue, Norway, Oman, Pakistan, Palau, Panama, Paraguay, Peru, Philippines, Pitcairn, Poland, Portugal, Qatar, Romania, Rwanda, Samoa, Senegal, Serbia, Seychelles, Singapore, Slovakia, Slovenia, Somalia, Spain, Sudan, Suriname, Swaziland, Sweden, Switzerland, Taiwan, Tajikistan, Thailand, Togo, Tokelau, Tonga, Tunisia, Turkey, Turkmenistan, Tuvalu, Uganda, Ukraine, Uruguay, Uzbekistan, Vanuatu, Venezuela, Yemen, Zambia, Zimbabwe, countries as default };
